module.exports = __webpack_public_path__ + "static/media/wallet-red.1076d4c1.png";